export const SENIORITY_DATE_FIELD_NAMES = [
  'anzianita-pubblica-amministrazione',
  'data-assunzione-in-enac',
  'anzianita-categoria-attuale',
  'anzianita-servizio',
] as const;

export const BLOCKING_SENIORITY_DATE_FIELD_NAMES =
  SENIORITY_DATE_FIELD_NAMES.slice(0, 3);

export function isSeniorityDateField(fieldName: unknown): boolean {
  return (
    typeof fieldName === 'string' &&
    SENIORITY_DATE_FIELD_NAMES.includes(
      fieldName as (typeof SENIORITY_DATE_FIELD_NAMES)[number],
    )
  );
}

export function isBlockingSeniorityDateField(fieldName: unknown): boolean {
  return (
    typeof fieldName === 'string' &&
    BLOCKING_SENIORITY_DATE_FIELD_NAMES.includes(
      fieldName as (typeof BLOCKING_SENIORITY_DATE_FIELD_NAMES)[number],
    )
  );
}

export function isValidDateInDdMmYyyyFormat(value: unknown): boolean {
  if (typeof value !== 'string') {
    return false;
  }

  const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(value);
  if (!match) {
    return false;
  }

  const day = Number(match[1]);
  const month = Number(match[2]);
  const year = Number(match[3]);
  if (year < 1) {
    return false;
  }

  const date = new Date(0);
  date.setUTCFullYear(year, month - 1, day);

  return (
    date.getUTCFullYear() === year &&
    date.getUTCMonth() === month - 1 &&
    date.getUTCDate() === day
  );
}
